import React from "react";
import { SelectOption } from "@showitinc/showit-wc";

import AppConstants from "../../../../constants/AppConstants";
import GallerySimpleProperties from "./GallerySimpleProperties";
import GalleryTiledProperties from "./GalleryTiledProperties";
import GallerySlidingProperties from "./GallerySlidingProperties";

import { initFormatter } from "../../../../utils/PropertyFormatters";
import Input from "../../../base/Input";
import { SELECT } from "../../../../constants/InputConstants.mjs";
import CustomizeEffects from "../../shared/CustomizeEffects";

const {
  ELEMENT_GALLERY_TYPE_SIMPLE,
  ELEMENT_GALLERY_TYPE_TILE,
  ELEMENT_GALLERY_TYPE_SLIDING,
  SELECT_EMPTY_OPTION_TEXT,
} = AppConstants;

const GALLERIES = {
  [ELEMENT_GALLERY_TYPE_SIMPLE]: {
    component: GallerySimpleProperties,
    label: "Simple Gallery",
  },
  [ELEMENT_GALLERY_TYPE_TILE]: {
    component: GalleryTiledProperties,
    label: "Tiled Gallery",
  },
  [ELEMENT_GALLERY_TYPE_SLIDING]: {
    component: GallerySlidingProperties,
    label: "Sliding Gallery",
  },
};

const GalleryOptions = Array.from({ length: 10 }).map((_, i) => {
  const val = i + 1;
  return (
    <SelectOption key={val} value={val}>
      {`Gallery ${val}`}
    </SelectOption>
  );
});

const GalleryProperties = ({
  element,
  isLocked,
  layout,
  onPropUpdate,
  preparedElement,
  mappedElement,
}) => {
  const { onChange: onSelect } = initFormatter(onPropUpdate);

  const galleryType = preparedElement.getIn(
    ["content", "type"],
    ELEMENT_GALLERY_TYPE_SIMPLE
  );
  const galleryNum = preparedElement.getIn(["content", "channel"], "");
  const GalleryComponent = GALLERIES[galleryType]?.component;

  return (
    <>
      <Input
        disabled={isLocked}
        inputType={SELECT}
        label="Type"
        onSISelect={onSelect("content.type", galleryType)}
        reserveContext
        shift="left"
        value={galleryType}
      >
        {Object.entries(GALLERIES).map(([val, { label }]) => (
          <SelectOption key={val} value={val}>
            {label}
          </SelectOption>
        ))}
      </Input>
      <Input
        disabled={isLocked}
        inputType={SELECT}
        label="Image Area"
        onSISelect={onSelect("content.channel", galleryNum)}
        reserveContext
        shift="left"
        value={galleryNum}
      >
        <SelectOption value="">{SELECT_EMPTY_OPTION_TEXT}</SelectOption>
        {GalleryOptions}
      </Input>
      {GalleryComponent ? (
        <GalleryComponent
          disabled={isLocked}
          element={element}
          layout={layout}
          onPropUpdate={onPropUpdate}
          preparedElement={preparedElement}
        />
      ) : null}
      <CustomizeEffects
        mappedElement={mappedElement}
        layout={layout}
        onPropUpdate={onPropUpdate}
        preparedElement={preparedElement}
      />
    </>
  );
};

export default GalleryProperties;
